import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'etoh-identifier',
  template: `
    <div class="identifier-wrapper">
      @if (cellValue) { @if (context.identifierLink) {
      <a
        nz-button
        [nzSize]="'small'"
        nzType="primary"
        [ngClass]="data?.archivedAt ? null : 'accent'"
        [routerLink]="['/features', context.dataType, 'edit', data.id]"
        [queryParams]="context.queryParams"
      >
        {{ cellValue }}
      </a>
      } @else {
      {{ cellValue }}
      } }
    </div>
  `,
  styleUrls: ['./identifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, NzButtonModule, RouterModule],
})
export class IdentifierComponent implements ICellRendererAngularComp {
  public cellValue: string;
  params!: ICellRendererParams;
  context: any;
  data: any;

  constructor() {}

  refresh(_params: ICellRendererParams<any, any>): boolean {
    return false;
  }
  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
    this.data = params.data;
    this.context = params.context;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params?.data?.id;
  }
}
